export default __webpack_public_path__ + "static/1028-6ad426b089c3780059cba4cf7f256c94.gif";